import { useTranslation } from "react-i18next";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";

import SoftButton from "components/SoftButton";

const DialogWrapper = ({
  open,
  closeDialog,
  title,
  size = "lg",
  onSave,
  children,
  isLoading = false
}) => {
  const { t } = useTranslation("flowDesigner");

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={size}
      onClose={closeDialog}
      aria-labelledby="flowVersionsDialogTitle"
      sx={{ "& .MuiPaper-root": { overflowY: "visible !important" } }}
    >
      <DialogTitle
        sx={{
          marginBottom: "20px",
          padding: "32px 0 0 48px"
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent sx={{ overflowY: "visible", padding: "0 48px 24px" }}>
        {children}
      </DialogContent>
      <DialogActions
        sx={{ display: "flex", justifyContent: "space-between", padding: "0 48px 32px" }}
      >
        <SoftButton
          sx={{ width: "100%" }}
          variant="outlined"
          color="secondary"
          onClick={closeDialog}
        >
          {t("buttons.cancel")}
        </SoftButton>
        <SoftButton sx={{ width: "100%" }} color="primary" onClick={onSave} disabled={isLoading}>
          {isLoading ? (
            <CircularProgress
              size={24}
              sx={{
                color: "#fff",
                position: "absolute",
                top: "50%",
                left: "50%",
                marginTop: "-12px",
                marginLeft: "-12px"
              }}
            />
          ) : (
            t("buttons.save")
          )}
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
};

export default DialogWrapper;
